// Pick the sport used to compute standings.
//
// Shared so the public standings page and the API's bracket advancement resolve
// the SAME sport for the same division. That matters because createStandings
// gates its whole tiebreaker chain on `sport === 'basketball'` — if the two
// sides disagreed on the sport they would produce different orderings, and the
// standings-rank fallback for a tied playoff game would advance a different team
// than the page highlighted. See ADR 0029.
//
// Per CLAUDE.md sport is single-sourced from `organization.sports[0]`. The
// sub-entity `sports` arrays are denormalized mirrors kept only as a fallback for
// legacy documents where the org lookup isn't at hand; this encodes the
// most-specific-first precedence the public app has always used.
import _ from 'lodash';

export interface StandingsSportSources {
  division?: any;
  /** The contest or standalone season the division belongs to. */
  league?: any;
  tournament?: any;
  organization?: any;
}

export const DEFAULT_STANDINGS_SPORT = 'basketball';

export default function resolveStandingsSport({
  division, league, tournament, organization,
}: StandingsSportSources = {}): string {
  return _.get(division, 'sports[0]')
    || _.get(league, 'sports[0]')
    || _.get(tournament, 'sports[0]')
    || _.get(organization, 'sports[0]')
    || DEFAULT_STANDINGS_SPORT;
}
